import React from "react";

const EmptyFiveDivs = () => {
    return (
        <>
        <div className='empty_div'></div>
        <div className='empty_div'></div>
        <div className='empty_div'></div>
        <div className='empty_div'></div>
        <div className='empty_div'></div>
      </>
    );
  };
  
  export default EmptyFiveDivs;